module.exports = ".resetSpinnerContainer{text-align:center;margin-bottom:2em}";